import { Col, Row, Space } from 'antd';

import { snapStore } from 'containers/Snaps/Snap/store';

import { EligibleOffers } from './EligibleOffers';
import { EligibleProducts } from './EligibleProducts';
import { OfferMatches } from './OfferMatches';
import { ProductMatches } from './ProductMatches';

export const Matching = () => {
  const canHaveOfferMatches = snapStore((state) => state.snapBooleanStatuses.canHaveOfferMatches);

  return (
    <Row className='w-full'>
      <Col xs={24}>

        <Space
          className='w-full'
          size={20}
          direction='vertical'
        >
          {canHaveOfferMatches && <OfferMatches />}

          <ProductMatches />

          {canHaveOfferMatches && <EligibleOffers />}

          <EligibleProducts />
        </Space>
      </Col>
    </Row>
  );
};
